import React, { useEffect, useContext } from 'react'
import './withdraw.css'
import M from "materialize-css";
import { StateContext } from "../App";
import axios from 'axios';

function Withdraw() {

    const { state, dispatch } = useContext(StateContext);
    const status = state.user && state.user.status

    useEffect(() => {
        var elems = document.querySelectorAll("select");
        var instances = M.FormSelect.init(elems);
    }, []);
    

    useEffect(() => {
        const notification = document.querySelector(".withdraw_status")

        if (status !== "") notification.style.display = "block"
    }, [ status ])

    
    const placeWithdrawRequest = (e) => {
        e.preventDefault();

        const button = document.querySelector(".withdraw-btn");

        button.textContent = "Processing..."
        
        const form = document.querySelector(".withdraw-request-form");
        const email = form.email.value;
        const amount = form.amount.value;
        const wallet_address = form.walletAddress.value;
        const crypto_type = form.walletType.value;

        const options = {
            email,
            amount,
            wallet_address,
            crypto_type
        }



        axios.post("/admin/request", options)
        .then(result => {
            button.textContent = "Withdraw Fund"
            // console.log(result);
            // console.log(result.data);

            result.data && alert(`Success! $${amount} has been requested for withdrawal, it is being processed at the moment and it will be credited to your wallet shortly.`)

            form.email.value = "";
            form.amount.value = "";
            form.walletAddress.value = "";
            form.walletType.value = "";
            
        })
        .catch(error => {
            button.textContent = "Withdraw Fund"
            console.log("ERR! Creating Withdrawal request ==>", error)
        })

    }
    

    return (
        <div className="withdraw">
            
            <p className="withdraw_status">{ status }</p>
            
            <h2>request fund withdrawal</h2>
            
            <div className="container">
                <form onSubmit={placeWithdrawRequest} className="center withdraw-request-form">
                    
                    <div className="input-field">
                        <input type="text" name="email" defaultValue={ state.user && state.user.email } />
                    </div>
                    
                    <div className="input-field">
                        <input className="deposit_amount_input" type="number" name="amount" placeholder="Enter an amount ($)" required />
                    </div>

                    {/* Wallet type! */}
                    <div className="input-field">
                        <select name="walletType" required className="browser-default _withdrawal-selectOption">
                            <option value="" disabled selected>select your wallet type</option>
                            <option value="bitcoin">bitcoin</option>
                            <option value="etheruem">etheruem</option>
                            <option value="litecoin">litecoin</option>
                            <option value="dogecoin">dogecoin</option>
                            <option value="bitcoin cash">bitcoin cash</option>
                        </select>
                    </div>
                               
                    <div className="input-field">
                        <input type="text" name="walletAddress" placeholder="Paste your wallet address here!" required />
                    </div>

                    <div className="input">
                        <button className="withdraw-btn"> Withdraw Fund</button>
                    </div>

                </form>
            </div>

        </div>
    )
}

export default Withdraw
